import { schedulesFeature } from './schedules.reducer';

export const { selectSchedules } = schedulesFeature;
